var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdminIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Phosphor Icons / UserCircleGear"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 94"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.99899 10.347C9.60513 10.347 10.9072 9.04495 10.9072 7.43881C10.9072 5.83267 9.60513 4.53064 7.99899 4.53064C6.39285 4.53064 5.09082 5.83267 5.09082 7.43881C5.09082 9.04495 6.39285 10.347 7.99899 10.347Z",
    stroke: "white",
    strokeWidth: 1.4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M3.33136 13.2115C3.76897 12.3495 4.43672 11.6256 5.2606 11.1199C6.08447 10.6142 7.03228 10.3465 7.99897 10.3465C8.96566 10.3465 9.91347 10.6142 10.7373 11.1199C11.5612 11.6256 12.229 12.3495 12.6666 13.2115",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.2337 3.94897C13.8761 3.94897 14.3969 3.42816 14.3969 2.7857C14.3969 2.14325 13.8761 1.62244 13.2337 1.62244C12.5912 1.62244 12.0704 2.14325 12.0704 2.7857C12.0704 3.42816 12.5912 3.94897 13.2337 3.94897Z",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M13.2337 1.62245V0.75",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M12.2231 2.20411L11.4742 1.76788",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M12.2231 3.36737L11.4742 3.8036",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M13.2337 3.94897V4.82143",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M14.2443 3.36737L14.9931 3.8036",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M14.2443 2.20411L14.9931 1.76788",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M14.9277 7.18428C14.963 7.46156 14.98 7.74087 14.9786 8.02038C14.9786 9.40081 14.5692 10.7502 13.8023 11.898C13.0354 13.0458 11.9453 13.9404 10.67 14.4687C9.39461 14.997 7.99124 15.1352 6.63733 14.8659C5.28342 14.5966 4.03978 13.9318 3.06366 12.9557C2.08755 11.9796 1.4228 10.7359 1.15349 9.38203C0.884183 8.02812 1.0224 6.62476 1.55067 5.3494C2.07894 4.07404 2.97354 2.98398 4.12133 2.21705C5.26912 1.45012 6.61855 1.04078 7.99899 1.04078C8.21503 1.03941 8.431 1.04912 8.64605 1.06986",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminIcon);
export default __webpack_public_path__ + "static/media/admin_icon.5c7c7d8b0d2d7ba6e16be4e91872f88c.svg";
export { ForwardRef as ReactComponent };